import type { Facility, StudioFacility } from '@bruce/api/common/facility'

export function sortFacilities(
  a: Facility | StudioFacility,
  b: Facility | StudioFacility,
) {
  if ('order' in a && 'order' in b) {
    return a.order - b.order
  } else if ('facility' in a && 'facility' in b) {
    return a.facility.order - b.facility.order
  } else {
    return 0
  }
}
